export enum SortingModes {
  DEFAULT,
  ASCEND,
  DESCEND,
}
